import React from 'react';
import { Nav, Form, Col, Row, Button, Navbar, Container, Image, Spinner } from 'react-bootstrap';
import axios, { AxiosRequestConfig } from 'axios';
import { Link } from 'react-router-dom';
import { Constants } from "../../constants";
import 'bootstrap/dist/css/bootstrap.min.css';

class ContractorRegister extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            input: {
                firstname: '',
                lastname: '',
                email: '',
                password: '',
                phonenumber: '',
                confirmpassword: ''
            },
            errors: {},
            loading: false
        };

        this.feedback = this.feedback.bind(this);
        this.showButton = this.showButton.bind(this);
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.validatePassword = this.validatePassword.bind(this);
    } 

    handleFormChange(event) {
        let input = this.state.input;
        let errors = this.state.errors;
        input[event.target.name] = event.target.value;
        if (!!errors[event.target.name]) {
            errors[event.target.name] = null;
        }

        this.setState({
            input,
            errors
        });
    }

    validate(event) {

        let input = this.state.input;
        let errors = {};
        let isValid = true;

        if (!input["firstname"]) {
            isValid = false;
            errors["firstname"] = "Please enter your name.";
        }
        if (!input["lastname"]) {
            isValid = false;
            errors["lastname"] = "Please enter your name.";
        }

        if (!input["phonenumber"] || !String(input["phonenumber"])
            .match(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/ )) {
            isValid = false;
            errors["phonenumber"] = "Invalid phone number.";
        }

        if (!input["email"] || !String(input["email"])
            .toLowerCase()
            .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            )) {
            isValid = false;
            errors["email"] = "Invalid email address.";
        }

        if (!input["password"]) {
            isValid = false;
            errors["password"] = "Please enter your password.";
        }

        if (!input["confirmpassword"]) {
            isValid = false;
            errors["confirmpassword"] = "Please confirm your password.";
        }

        if (typeof input["password"] !== "undefined" && typeof input["confirmpassword"] !== "undefined") {

            if (input["password"] != input["confirmpassword"]) {
                isValid = false;
                errors["confirmpassword"] = "Passwords don't match.";
            }
        }

        console.log(errors);

        this.setState({
            errors: errors
        });

        return isValid;
    }

    validatePassword(event) {
        let input = this.state.input;
        input["password"] = event.target.value;
        let errors  = this.state.errors;
        if (typeof input["password"] == "undefined" || !String(input["password"])
            .match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/)) {
            errors["password"] = <div style={{ lineHeight: .5, marginTop:3 }}><p>Passwords require at least:</p><p>1 uppercase letter.</p><p>1 lowercase letter.</p><p>1 number.</p><p>1 symbol.</p><p>8-16 characters in length.</p></div>
        }
        else {
            errors["password"] = "";
        }

        this.setState({
            input: input,
            errors: errors
        });
    }

    showButton() {
        if (this.state.loading) {
            return <Button style={{ marginLeft: '30px', backgroundColor: '#1F419B' }} variant="primary" disabled>
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>;
        }
        else {
            return <Button style={{ marginLeft: '30px', backgroundColor: '#1F419B' }} variant="primary" type="submit">
                Register
            </Button>;
        }
    }

    handleSubmit(event) {

        event.preventDefault();
        
        if (!this.validate()) {
            alert('Please fill in required fields to proceed.');
            return;
        }

        this.setState({ loading: true });

        axios.post(`${Constants.apiURL}/api/Identity/ContractorRegister`, {
            firstname: this.state.input.firstname,
            lastname: this.state.input.lastname,
            email: this.state.input.email,
            password: this.state.input.password,
            phonenumber: this.state.input.phonenumber
        }).then(response => {
            console.log(response);
            if (response.status == 200 && response.data == true) {
                alert('Account created. Please login below.');
                this.props.history.push({
                    pathname: '/contractor_login'
                });
            }
            else {
                alert(response.data);
            }
            this.setState({ loading: false });
        }).catch((error) => {
            this.setState({ loading: false });
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                alert('Unable to register your account.Please email clientportal@boland.com to request an account.');
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                alert('Error contacting server. Please try again soon.')
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
        });
    }
    feedback() {

        this.props.history.push({
            pathname: "/feedback",
            state: {
                previousPage: this.state.currentPage
            }
        });
    }

    render() {
        return (
            <div>
                <Navbar className="boland-navbar" collapseOnSelect expand="md" defaultExpanded={false} sticky="top" style={{ paddingTop: '3px', paddingBottom: '3px' }}>
                    <Container style={{ marginLeft: '0px', paddingRight: 0, maxWidth: '100%' }}>
                        <Navbar.Brand as={Link} to={{
                            pathname: "/contractor_portal",
                            state: {
                                user: this.state.user,
                                contrator: this.state.contractor
                            }
                        }}>
                            <Image src="./Boland block 2.png" width="165px" height="40px" />
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav className="ml-auto" style={{ width: '100%' }}>

                                <div style={{ width: '100%' }} />
                                <Button size="sm" className="justify-content-end" style={{ justifyContent: 'end', backgroundColor: '#EF4139', minWidth: 'max-content' }} onClick={this.feedback}>
                                    Feedback? Let us know here.
                                </Button>
                                <Nav.Link href="https://www.boland.com/training-events" target="_blank">Training</Nav.Link>
                                <Nav.Link href="https://www.boland.com/news" target="_blank">News</Nav.Link>
                                <Button className="justify-content-end" style={{ justifyContent: 'end', backgroundColor: '#1F419B' }} onClick={() => {

                                    this.props.history.push({
                                        pathname: "/contractor_login"
                                    });
                                }}>
                                    Login/Register
                                </Button>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
                <Form onSubmit={this.handleSubmit} noValidate >
                    <Row style={{ padding: '10px', margin: '10px', maxWidth: '800px' }} className="mb-3">
                        <Col md>
                            <Form.Label style={{ paddingBottom: '24px' }} className="form-header">Your information</Form.Label>
                            <Form.Group className="mb-3" controlId="formFirstname">
                                <Form.Label>First name</Form.Label>
                                <Form.Control type="input" name="firstname" value={this.state.input.firstname} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.firstname} />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formLastname">
                                <Form.Label>Last name</Form.Label>
                                <Form.Control type="input" name="lastname" value={this.state.input.lastname} onChange={this.handleFormChange} required
                                    isInvalid={!!this.state.errors.lastname} />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formPhoneNumber">
                                <Form.Label>Phone number</Form.Label>
                                <Form.Control type="phone" name="phonenumber" value={this.state.input.phonenumber} onChange={this.handleFormChange} required
                                    isInvalid={!!this.state.errors.phonenumber} />
                                <Form.Control.Feedback type='invalid'>
                                    {this.state.errors.phonenumber}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control type="email" name="email" value={this.state.input.email} onChange={this.handleFormChange} required
                                    isInvalid={!!this.state.errors.email} />
                                <Form.Control.Feedback type='invalid'>
                                    {this.state.errors.email}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                <Form.Label>Password</Form.Label>
                                <Form.Control type="password" name="password" value={this.state.input.password} onChange={this.validatePassword} required
                                    isInvalid={!!this.state.errors.password} />
                                <Form.Control.Feedback type='invalid'>
                                    {this.state.errors.password}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicPasswordConfirm">
                                <Form.Label>Confirm password</Form.Label>
                                <Form.Control type="password" name="confirmpassword" value={this.state.input.confirmpassword} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.confirmpassword} />
                                <Form.Control.Feedback type='invalid'>
                                    {this.state.errors.confirmpassword}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                    {this.showButton()}
                </Form>
            </div>
        );
    }
}

export default ContractorRegister;